export enum NumberServiceType {
  CORPORATE = 'CORPORATE',
  DUMMY = 'DUMMY',
  MSISDN = 'MSISDN',
  PSTN = 'PSTN',
  SERVICE = 'SERVICE',
  VIRTUAL = 'VIRTUAL',
  VOICEMAIL = 'VOICEMAIL',
  UNKNOWN = 'UNKNOWN',
}

export enum NumberType {
  FIXED_NETWORK = 'FIXED_NETWORK',
  MOBILE = 'MOBILE',
  UNKNOWN = 'UNKNOWN',
}
